export const TenantType = {
  Club: 0,
  Organization: 1,
}
